import { Box, Stack, Switch, Typography } from "@mui/material";
import { useTicketTableContext, useTicketTableDispatch } from "@hooks/use-table-context/ticket";

export const ClosedTicketsFilter = () => {
    const { toggleShowClosedTickets } = useTicketTableDispatch();
    const { showClosed } = useTicketTableContext();

        // Show Closed Tickets Toggle Handler
    const handleShowClosedToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        toggleShowClosedTickets();
    }
    return (
            <Box sx={{ pl: 0.5 }}>
                <Stack direction="row" alignItems="center">
                    <Switch
                        checked={showClosed ?? false}
                        onChange={handleShowClosedToggle}
                        size="small"
                        sx={{ ml: 1 }}
                    />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        Show Closed Tickets
                    </Typography>
                </Stack>
            </Box> 
    )
}